import type { IconComponentType } from "./IconType";

const Icon: React.FC<IconComponentType> = ({ icon: Icon, size = 16, color, styles = {}, className }) => {
    return <Icon size={size} color={color} style={styles} className={className} />
}
export default Icon;